import type { ButtonHTMLAttributes, PropsWithChildren } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'quiet' | 'danger';
  full?: boolean;
}

export function Button({ variant = 'secondary', full = false, className = '', children, ...props }: PropsWithChildren<ButtonProps>): React.JSX.Element {
  return (
    <button className={`button button--${variant}${full ? ' button--full' : ''} ${className}`.trim()} {...props}>
      {children}
    </button>
  );
}
